import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import CtaButton from 'components/essentials/Cta/CtaButton';
const SubmitPhotosUploaded = t0 => {
  const $ = _c(4);
  const {
    onSubmitAnotherPhotoClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-2xl font-bold text-gray text-center mt-0 mx-0 mb-4 md:mt-8">Your photo has been received and is now in review!</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-base mx-0 my-4 md:mb-12">We will email you to let you know when your photo has been approved and is live on our <CtaLink to="/customer-photos/" color="brand" noLinkPadding={true} hasArrow={false} textClassName="!lowercase">Inspiration</CtaLink> page! As soon as it’s approved, you’ll see an email from us with details on how to redeem your $25 gift card.</div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSubmitAnotherPhotoClick) {
    t3 = <div>{t1}{t2}<div className="flex justify-center"><CtaButton color="brand" noLinkPadding={true} hasArrow={false} styling="outline-button" onClick={onSubmitAnotherPhotoClick} textClassName="!lowercase">Submit Another Photo</CtaButton></div></div>;
    $[2] = onSubmitAnotherPhotoClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
SubmitPhotosUploaded.propTypes = {
  onSubmitAnotherPhotoClick: PropTypes.func
};
export default SubmitPhotosUploaded;